import { InjectionToken, Signal, signal } from '@angular/core';

export const REPORT_MODE_ENABLED = new InjectionToken<Signal<boolean>>('reportState', { factory: () => signal(false) });
